import type { RouteObject } from "react-router-dom";

export const warehouseManagementRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Redo Warehouse" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { WarehouseManagementPage } =
            await import("../pages/warehouse-management/warehouse-management-page");

          return { Component: WarehouseManagementPage };
        },
      },
      {
        path: "fulfillment-group-rates",
        handle: { breadcrumb: "Fulfillment group rates" },
        async lazy() {
          const { FulfillmentGroupRatesPage } =
            await import("../pages/fulfillment-group-rates/fulfillment-group-rates-page");

          return { Component: FulfillmentGroupRatesPage };
        },
      },
      {
        path: "error-messages",
        handle: { breadcrumb: "Error messages" },
        async lazy() {
          const { ErrorMessagesPage } =
            await import("../pages/error-messages/error-messages-page");

          return { Component: ErrorMessagesPage };
        },
      },
      {
        path: "developer-tools",
        handle: { breadcrumb: "Developer tools" },
        async lazy() {
          const { DeveloperToolsPage } =
            await import("../../developer-tools/developer-tools-page");

          return { Component: DeveloperToolsPage };
        },
      },
      {
        path: "supplies",
        handle: { breadcrumb: "Supplies" },
        children: [
          {
            path: "price-books",
            handle: { breadcrumb: "Price books" },
            children: [
              {
                index: true,
                async lazy() {
                  const { RedoSuppliesPriceBooksPage } =
                    await import("../pages/redo-supplies-price-books/redo-supplies-price-books-page");

                  return { Component: RedoSuppliesPriceBooksPage };
                },
              },
              {
                path: ":priceBookId",
                async lazy() {
                  const { PriceBookDetailPage } =
                    await import("../pages/redo-supplies-price-books/price-book-detail-page");

                  return { Component: PriceBookDetailPage };
                },
              },
            ],
          },
          {
            path: "trackable-products",
            handle: { breadcrumb: "Trackable products" },
            async lazy() {
              const { TrackableProductsPage } =
                await import("../pages/supplies-trackable-products/trackable-products-page");

              return { Component: TrackableProductsPage };
            },
          },
          {
            path: "storefront-customization",
            handle: { breadcrumb: "Storefront customization" },
            async lazy() {
              const { StorefrontCustomizationPage } =
                await import("../pages/supplies-storefront-customization/storefront-customization-page");

              return { Component: StorefrontCustomizationPage };
            },
          },
        ],
      },
    ],
  },
];
